"use client";

import {
  Link2,
} from "lucide-react";
import { Twitter, Facebook } from "@/components/icons/social-icons";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { env } from "@/env";

type ShareButtonsProps = {
  title: string;
  slug: string;
};

export function ShareButtons({ title, slug }: ShareButtonsProps) {
  const url = `${env.NEXT_PUBLIC_BASE_URL}/blog/${slug}`;

  const encodedTitle = encodeURIComponent(title);
  const encodedUrl = encodeURIComponent(url);

  function copyLink() {
    navigator.clipboard.writeText(url);
    toast.success("Enlace copiado");
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-white/40">Compartir:</span>
      <Button
        variant="outline"
        size="icon"
        className="h-8 w-8 border-white/10"
        asChild
      >
        <a
          href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Compartir en Twitter"
        >
          <Twitter className="h-3.5 w-3.5" />
        </a>
      </Button>
      <Button
        variant="outline"
        size="icon"
        className="h-8 w-8 border-white/10"
        asChild
      >
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Compartir en Facebook"
        >
          <Facebook className="h-3.5 w-3.5" />
        </a>
      </Button>
      <Button
        variant="outline"
        size="icon"
        className="h-8 w-8 border-white/10"
        onClick={copyLink}
        aria-label="Copiar enlace"
      >
        <Link2 className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
